// Shutter styles with icons/images
export const SHUTTER_STYLES = [
  {
    id: 'full_height',
    name: 'Full Height',
    description: 'Floor to ceiling coverage',
    image: 'https://static.prod-images.emergentagent.com/jobs/b91ea611-2364-4d55-8415-0e2be2797319/images/79f2e9a3e46d63c12d78f97eafcab5112c7aa1e3bfaeb76a3fc34cf30ef86b44.png'
  },
  {
    id: 'cafe_style',
    name: 'Cafe Style',
    description: 'Bottom half coverage',
    image: 'https://static.prod-images.emergentagent.com/jobs/b91ea611-2364-4d55-8415-0e2be2797319/images/4c42b25297bb9cdc957f101999155b8d77aa410c72b2933afc193f514b59c0df.png'
  },
  {
    id: 'tier_on_tier',
    name: 'Tier on Tier',
    description: 'Independent top & bottom',
    image: 'https://static.prod-images.emergentagent.com/jobs/b91ea611-2364-4d55-8415-0e2be2797319/images/587d19c8b4573aed50340d8e079badc98afc137cb37f38b7d447fc336fc69c5d.png'
  }
];

// Materials with price indicators (prices are per sqm, inc VAT shown to customer)
export const MATERIALS = [
  {
    id: 'budget',
    name: 'Budget',
    description: 'Quality shutters at an affordable price',
    pricePerSqm: 191.67,
    priceIncVat: 230,
    bayWindowPremium: 20,
    indicator: '\u00a3',
    note: 'Great value - includes survey, installation & VAT',
    features: [
      '10 Year Structural Warranty',
      'Survey Included',
      'Professional Installation',
      'All-Inclusive Pricing'
    ]
  },
  {
    id: 'polymer',
    name: 'Polymer',
    description: 'Market leading water resistance with full hidden tilt option',
    pricePerSqm: 250,
    priceIncVat: 300,
    bayWindowPremium: 20,
    indicator: '\u00a3\u00a3',
    note: 'Recommended for bathrooms & wetrooms',
    features: [
      'Certified Non Toxic',
      'EU REACH Compliant',
      'Flame Retardant',
      '10 Year Structural Warranty',
      'Made From Virgin Material, Not Recycled',
      'Suitable for Commercial Environments',
      'Maintenance Free & Easy Cleaning'
    ]
  },
  {
    id: 'paulownia',
    name: 'Paulownia+',
    description: 'Lightweight hardwood shutters encased in a hard wearing polymer casing',
    pricePerSqm: 250,
    priceIncVat: 300,
    bayWindowPremium: 20,
    indicator: '\u00a3\u00a3\u00a3',
    note: null,
    recommended: true,
    recommendedLabel: 'Best Combination of Quality & Price',
    features: [
      '10 Year Structural Warranty',
      'Hardwood Encased In Polymer',
      'Hard Wearing & Durable',
      'Excellent Thermal Insulation',
      'Lightweight & Strong',
      'Wide Colour Range Available'
    ]
  },
  {
    id: 'basswood',
    name: 'Basswood',
    description: 'Premium hardwood, superior finish',
    pricePerSqm: 291.67,
    priceIncVat: 350,
    bayWindowPremium: 20,
    indicator: '\u00a3\u00a3\u00a3\u00a3',
    note: 'Premium range',
    features: [
      '10 Year Structural Warranty',
      'Smooth Grain Finish',
      'Harder Impact Resistance',
      'Superior Quality Hardwood',
      'Wide Colour Range Available'
    ]
  },
  {
    id: 'uk_basswood',
    name: 'UK Made Basswood',
    description: 'Premium UK manufactured basswood shutters',
    pricePerSqm: 337.50,
    priceIncVat: 405,
    bayWindowPremium: 20,
    indicator: '\u00a3\u00a3\u00a3\u00a3\u00a3',
    note: '4-5 week lead time',
    features: [
      '10 Year Structural Warranty',
      'Made In The UK',
      '4-5 Week Lead Time',
      'Premium Quality Basswood',
      'Superior Finish & Craftsmanship'
    ]
  },
  {
    id: 'aluminium',
    name: 'Aluminium',
    description: 'T6 Aircraft Grade Aluminium for external & security use',
    pricePerSqm: 350,
    priceIncVat: 420,
    indicator: '\u00a3\u00a3\u00a3\u00a3\u00a3',
    note: 'Ideal for external use & added home security',
    features: [
      'For External Use',
      'Built To Withstand Harsh UK Weather Conditions',
      'Can Be Installed Internally With Locks & Keys For Added Home Security',
      'T6 Aircraft Grade Aluminium',
      'Vertical or Horizontal Louvres'
    ]
  }
];

// Installation types (Full Service only)
export const INSTALLATION_TYPES = [
  {
    id: 'full_service',
    name: 'Full Service',
    description: 'We Measure, We Make, We Install',
    shortDesc: 'Professional installation included',
    warranty: '10 Year Structural Warranty'
  }
];

// Warranty info
export const WARRANTY_YEARS = 10;

export const INITIAL_FORM_DATA = {
  name: '',
  email: '',
  phone: '',
  postcode: '',
  shutterStyle: 'full_height',
  material: 'paulownia',
  installationType: 'full_service',
  uploadedImage: null,
  uploadedImagePreview: null,
  generatedPreview: null,
  windows: [{ id: 1, width: '', height: '', label: '', windowType: 'flat' }],
  unit: 'mm'
};

export const STEPS = [
  { number: 1, name: 'Details' },
  { number: 2, name: 'Configure' },
  { number: 3, name: 'Sizes' }
];
